// LoginForm module: toggles between register and login forms (classical POST submission handled server-side)

function initLoginForm(context = document) {
  const blocks = Array.from(context.querySelectorAll('.login'));
  blocks.forEach(block => {
    // only consider the top-level switch buttons inside .login__switch
    const switchButtons = Array.from(block.querySelectorAll('.login__switch [data-login-switch]'));
    const registerForm = block.querySelector('.register-form');
    const loginForm = block.querySelector('.login-only');
    const lostForm = block.querySelector('.lostpassword-form');

    function show(mode) {
      // hide all
      if (registerForm) registerForm.style.display = 'none';
      if (loginForm) loginForm.style.display = 'none';
      if (lostForm) lostForm.style.display = 'none';

      if (mode === 'register' && registerForm) registerForm.style.display = 'block';
      if (mode === 'login' && loginForm) loginForm.style.display = 'block';
      if (mode === 'lostpassword' && lostForm) lostForm.style.display = 'block';
        updateSwitchButtons(mode);
    }

      function updateSwitchButtons(mode) {
        // when register form is visible, show the login switch button (so user can go to login)
        // when login form is visible, show the register switch button
        let desired;
        if (mode === 'register') desired = 'login';
        else if (mode === 'login') desired = 'register';
        else desired = 'login'; // for lostpassword show login

        switchButtons.forEach(btn => {
          const target = btn.getAttribute('data-login-switch');
          if (target === desired) {
            btn.style.display = '';
          } else {
            btn.style.display = 'none';
          }
        });
      }

    switchButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const mode = btn.getAttribute('data-login-switch');
        show(mode);
      });
    });

    // also wire any in-form buttons/links that switch the view (e.g. "Zapomenuté heslo?")
    const inlineSwitchButtons = Array.from(block.querySelectorAll('.form [data-login-switch]'));
    inlineSwitchButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        // don't submit if it's a button inside a form
        e.preventDefault();
        const mode = btn.getAttribute('data-login-switch');
        show(mode);
      });
    });

    // initialize visible switch button according to currently visible form
    let initialMode = 'login';
    try {
      if (registerForm && window.getComputedStyle(registerForm).display !== 'none') initialMode = 'register';
      if (loginForm && window.getComputedStyle(loginForm).display !== 'none') initialMode = 'login';
      if (lostForm && window.getComputedStyle(lostForm).display !== 'none') initialMode = 'lostpassword';
    } catch (e) {
      // ignore, fallback to login
    }
    // If URL contains login_mode=login (e.g. after successful registration), switch to login
    const params = new URLSearchParams(window.location.search);
    if (params.get('login_mode') === 'login') {
      show('login');
      // remove the param from URL without reloading
      params.delete('login_mode');
      const newUrl = window.location.pathname + (params.toString() ? ('?' + params.toString()) : '') + window.location.hash;
      window.history.replaceState({}, document.title, newUrl);
    } else {
      show(initialMode);
    }
  });
}

export default initLoginForm;

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initLoginForm(document));
  else initLoginForm(document);
}
